/**
 * 项目信息
 */

import request from '@/utils/request'

/**
 * 根据条件分页查询项目
 * @param data
 */
export function projectSelectPage(data) {
  return request({
    url: '/project/select/page',
    method: 'post',
    data
  })
}

/**
 * 新增项目
 * @param data
 */
export function projectAdd(data) {
  return request({
    url: '/project/add',
    method: 'post',
    data
  })
}

/**
 * 新增查阶段接口
 * @param data
 */
export function latestApproved(data) {
  return request({
    url: '/project/company/phase/latestApproved',
    method: 'post',
    data
  })
}

/**
 * 修改项目
 * @param data
 */
export function projectUpdate(data) {
  return request({
    url: '/project/update',
    method: 'post',
    data
  })
}

/**
 * 批量删除项目
 * @param ids
 */
export function projectBatchDelete(ids) {
  return request({
    url: '/project/batch/delete',
    method: 'post',
    data: {
      ids: ids
    }
  })
}

/**
 * 根据主键ID查询项目
 * @param id
 */
export function projectSelectById(id) {
  return request({
    url: '/project/select/byId',
    method: 'post',
    data: {
      id: id
    }
  })
}

/**
 * 导入项目
 * @param id
 */
export function projectImport(data) {
  return request({
    url: '/project/import',
    method: 'post',
    data: data
  })
}

/**
 * 根据项目查询当前最新的流程
 * @param id
 */
export function projectProcessLatest(id) {
  return request({
    url: '/project/process/latest',
    method: 'post',
    data: {
      projectId: id
    }
  })
}

/**
 * 查询项目最新计划
 * @param id
 */
export function projectProcessLatestPlan(id) {
  return request({
    url: '/project/process/latest/plan',
    method: 'post',
    data: {
      projectId: id
    }
  })
}

/**
 * 更新项目计划
 * @param id
 */
export function projectProcessUpdatePlan(data) {
  return request({
    url: '/project/process/update/plan',
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 根据项目查询当前最新的已通过流程
 * @param id
 */
export function projectProcessLatestApproved(id) {
  return request({
    url: '/project/process/latest/approved',
    method: 'post',
    data: {
      projectId: id
    }
  })
}

/**
 * 更新项目流程，保存草稿
 * @param data
 */
export function projectProcessSave(data) {
  return request({
    url: '/project/process/save',
    method: 'post',
    data
  })
}

/**
 * 更新项目流程，提交审批
 * @param data
 */
export function projectProcessSubmit(data) {
  return request({
    url: '/project/process/submit',
    method: 'post',
    data
  })
}

/**
 * 查询项目审批历史
 * @param id
 */
export function projectProcessApprovalHistory(id) {
  return request({
    url: '/project/process/approval/history',
    method: 'post',
    data: {
      projectId: id
    }
  })
}

/**
 * 保存阶段执行
 * @param data
 */
export function projectProcessSavePhase(data) {
  return request({
    url: '/project/process/save/phase',
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 保存阶段执行
 * @param data
 */
export function projectProcessSubmitPhase(data) {
  return request({
    url: '/project/process/submit/phase',
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 查询项目审批历史
 * @param id
 */
export function projectProcessLatestIsApproved(id) {
  return request({
    url: '/project/process/latest/isApproved',
    method: 'post',
    data: {
      projectId: id
    }
  })
}

/**
 * 查询项目授权用户列表
 * @param data
 */
export function userGetPermissionCompany(data) {
  return request({
    url: '/project/select/user/assign',
    method: 'post',
    data
  })
}
/**
 * 权限管理的字典列表
 * @param data
 */
export function dictGetDataType(data) {
  return request({
    url: '/base/enums/select/dictionaries/type',
    method: 'post',
    data
  })
}
/**
 * 权限管理的地区列表
 * @param data
 */
export function areaSelectList(data) {
  return request({
    url: '/area/selectList',
    method: 'post',
    data
  })
}
/**
 * 权限管理的获取地区的列表
 * @param data
 */
export function baseProcessSelectStage(data) {
  return request({
    url: '/base/process/selectStage',
    method: 'post',
    data
  })
}
/**
 * 用户授权
 * @param data
 */
export function userAuthorizeCompany(data) {
  return request({
    url: '/project/user/assign',
    method: 'post',
    data
  })
}

/**
 * 根据当前登录人权限查询项目
 * @param data
 */
export function projectSelect(data) {
  return request({
    url: '/project/select',
    method: 'post',
    data: data
  })
}

/**
 * 查询项目授权用户列表
 * @param data
 */
export function projectSelectAssign(data) {
  return request({
    url: '/project/select/assign',
    method: 'post',
    data
  })
}

/**
 * 查询项目授权用户列表
 * @param data
 */
export function projectUserAssign(data) {
  return request({
    url: '/project/select/user/assign/users',
    method: 'post',
    data
  })
}

/**
 * 项目用户授权
 * @param data
 */
export function projectAssign(data) {
  return request({
    url: '/project/assign',
    method: 'post',
    data
  })
}

/**
 * 公司的技术领域
 * @param data
 */
export function projectCompanyTechnicalArea(companyId) {
  return request({
    url: '/project/company/technicalArea',
    method: 'post',
    data: {
      companyId: companyId
    }
  })
}

/**
 * 查询公司某技术领域下的最新流程是否处于待审批状态
 * @param companyId
 * @param technicalArea
 */
export function projectCompanyLatestProcessInApproval(companyId, technicalArea) {
  return request({
    url: '/project/company/latestProcess/inApproval',
    method: 'post',
    data: {companyId: companyId, technicalArea: technicalArea}
  })
}

/**
 * 批量启用、禁用项目
 * @param ids
 * @param isAvaliable
 */
export function projectBatchAvaliable(ids, isAvaliable) {
  return request({
    url: '/project/batch/avaliable',
    method: 'post',
    data: { ids: ids, isAvaliable: isAvaliable }
  })
}